import React from 'react';
import FrameworkUtils from 'utils/framework';
import { Flex, Box } from 'components/ui';
import {
    space, fontSizes, lineHeights, colors
} from 'style/config';
import Markdown from 'components/Markdown/Markdown';
import convertMarkdownLinksToJiraFormat from 'ai/utils/convertMarkdownLinksToJiraFormat';

const { wrapFunctionalComponent } = FrameworkUtils;

function InitialMessages(props) {
    const { config, hideWelcomeMessage } = props;
    const cleanDisclaimer = convertMarkdownLinksToJiraFormat(config?.meta?.consent_disclaimer);

    return (
        <Flex
            gap={5}
            flexDirection='column'
            width='100%'
        >
            {config?.meta?.consent_disclaimer && (
                <Box css={[styles.disclaimer]}>
                    <Markdown content={cleanDisclaimer} />
                </Box>
            )}

            {config?.meta?.welcome_message && !hideWelcomeMessage && (
                <Flex css={styles.messageContainer}>
                    <Box css={[styles.message, styles.received]}>
                        <Markdown content={config?.meta?.welcome_message} />
                    </Box>
                </Flex>
            )}
        </Flex>
    );
}

const styles = {
    messageContainer: {
        paddingRight: '20%'
    },
    disclaimer: {
        fontSize: fontSizes.sm,
        lineHeight: lineHeights.tight,
        color: colors.black
    },
    message: {
        padding: space[3],
        borderRadius: 12,
        fontSize: fontSizes.base,
        lineHeight: lineHeights.tight
    },
    received: {
        backgroundColor: colors.nearWhite,
        color: colors.black,
        borderBottomLeftRadius: 0
    }
};

export default wrapFunctionalComponent(InitialMessages, 'InitialMessages');
